import { createRouter, createWebHistory } from 'vue-router';

const DEFAULT_TITLE = '璟馨婦幼醫院';
const routes = [
  {
    path: '/home',
    component: () => import('@/views/Home.vue'),
    meta: { title: '璟馨婦幼醫院' },
  },
  {
    path: '/member/login',
    component: () => import('@/views/Member/Login.vue'),
    meta: { title: '登入' },
  },
  {
    path: '/member/account-recovery',
    component: () => import('@/views/Member/AccountRecovery.vue'),
    meta: { title: '忘記密碼' },
  },
  {
    path: '/member/sign-up',
    component: () => import('@/views/Member/SignUp.vue'),
    meta: { title: '申請帳號' },
  },
  {
    path: '/member/setting',
    component: () => import('@/views/Member/Setting.vue'),
    meta: { title: '帳號設定' },
  },
  {
    path: '/privacy',
    component: () => import('@/views/Common/Privacy.vue'),
    meta: { title: '隱私權政策' },
  },
  {
    path: '/inbox',
    component: () => import('@/views/Inbox/Index.vue'),
    meta: { title: '訊息中心' },
  },
  {
    path: '/inbox/satisfaction-survey/:isCloseToHome?',
    component: () => import('@/views/Inbox/SatisfactionSurvey/Index.vue'),
    meta: { title: '滿意度調查' },
  },
  {
    path: '/appointment',
    component: () => import('@/views/Appointment/Index.vue'),
    meta: { title: '網路預約' },
  },
  {
    path: '/appointment/doctor',
    component: () => import('@/views/Appointment/Doctor/Index.vue'),
    meta: { title: '預約掛號' },
  },
  {
    path: '/appointment/doctor/making',
    component: () => import('@/views/Appointment/Doctor/Making/Index.vue'),
    meta: { title: '預約掛號' },
  },
  {
    path: '/appointment/doctor/query',
    component: () => import('@/views/Appointment/Doctor/Query/Index.vue'),
    meta: { title: '預約查詢' },
  },
  {
    path: '/appointment/schedule/:division?',
    component: () => import('@/views/Appointment/Schedule.vue'),
    meta: { title: '門診總表' },
  },
  {
    path: '/appointment/mothering-class',
    component: () => import('@/views/Appointment/MotheringClass.vue'),
    meta: { title: '媽媽教室預約' },
  },
  {
    path: '/progress',
    component: () => import('@/views/Progress/Index.vue'),
    meta: { title: '看診進度' },
  },
  {
    path: '/hibaby',
    component: () => import('@/views/Hibaby/Index.vue'),
    meta: { title: '超音波影像' },
  },
  {
    path: '/introduction',
    component: () => import('@/views/Introduction/Index.vue'),
    meta: { title: '院所介紹' },
  },
  {
    path: '/introduction/doctor',
    component: () => import('@/views/Introduction/Doctor/Index.vue'),
    meta: { title: '醫療團隊' },
  },
  {
    path: '/introduction/about-us',
    component: () => import('@/views/Introduction/AboutUs.vue'),
    meta: { title: '關於我們' },
  },
  {
    path: '/introduction/find-us',
    component: () => import('@/views/Introduction/FindUs.vue'),
    meta: { title: '交通資訊' },
  },
  {
    path: '/feedback',
    component: () => import('@/views/Feedback.vue'),
    meta: { title: '意見回饋' },
  },
  {
    path: '/test',
    component: () => import('@/views/Test.vue'),
    meta: { title: '測試' },
  },
  {
    path: '/device/:device_token/:os/:openMode?',
    component: () => import('@/views/Initialization.vue'),
    meta: { title: '儲存 Device Token' },
  },
  {
    path: '/auth/:openMode?',
    component: () => import('@/views/Auth.vue'),
    meta: { title: '驗證 Device Token' },
  },
  {
    path: '/devx',
    component: () => import('../views/Devx.vue'),
    meta: { title: 'Devx' },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || DEFAULT_TITLE;
  next();
});

router.afterEach((to) => {
  if (to.hash === '') {
    return;
  }
  if (to.query) {
    router.replace({
      path: to.path,
      query: to.query,
    });
    return;
  }
  router.replace(to.path);
});
export default router;
